import {IContextLayerQuery} from "./context-layer-query";
import {L} from "../../lt-ng/landcare-toolkit";
import {LTServices} from "../../lt-ng/lt-services";
import {IPortalServices, IRequestError} from "../../lt-ng/portal-services";
import GeoJSON from "ol/format/GeoJSON";
import {Feature} from "ol";
import {transform} from "ol/proj";
import {Coordinate} from "ol/coordinate";
import {Geometry} from "ol/geom";
import {IPointReport} from "../../services/ISharedFeatureState";

export class PortalsServicesLayerQuery implements IContextLayerQuery {
    constructor(protected layerService: L.util.LayerService,
                protected $http: ng.IHttpService,
                protected mapService: LTServices.IMapService,
                protected portalService: IPortalServices) {

    }

    layerName() {
        const pfl = this.layerService.attributes.PredefinedFeatureLayer;
        if (pfl) {
            return  pfl === 'true' ? this.layerService.layerName : pfl;
        } else {
            return this.layerService.layerName;
        }
    }

    get featureName(): string {
        return this.layerService.description;
    }

    get titleProperty(): string {
        return this.layerService.attributes && this.layerService.attributes.PredefinedFeatureTitleProperty;
    }

    queryPoint(coordinate: Coordinate): ng.IPromise<Array<Feature<Geometry>>> {
        const transformedCoordinate = transform(coordinate, 'EPSG:4326', 'EPSG:2193');

        return this.portalService.dataPointQuery(transformedCoordinate, this.layerName(), {}, true)
            .then((data: IPointReport|IRequestError) => {
                if ('error' in data) {
                    throw Error(data.error);
                }

                const layer = data.response.layers.find(l => l.name === this.layerName());
                if (!layer.rows.length) {
                    // throw Error("No geometry found");
                    return [];
                }

                const row = layer.rows[0];
                const geom_column = row.columns.find(c => c.name === 'INTERNAL_GEOMETRY');

                const fmt = new GeoJSON();
                const geometry = fmt.readGeometry(<string> geom_column.value);

                const titleProp = this.layerService.attributes && this.layerService.attributes.PredefinedFeatureTitleProperty;

                const f = new Feature(geometry);

                f.set('sourceLayerId', this.layerService.id);

                if (titleProp) {
                    const maybeTitle = row.columns.find(c => c.name === titleProp);
                    if (maybeTitle) {
                        f.set('_title', maybeTitle.value);
                    }
                }

                row.columns.filter(c => c.name.indexOf('INTERNAL') !== 0)
                    .forEach(c => {
                        f.set(c.name, c.value);
                    });

                return [f];
            })
    }

    queryPointProperties(coordinate: Coordinate, propertyName: string[], cache?: boolean): ng.IPromise<Array<any>> {
        const transformedCoordinate = transform(coordinate, 'EPSG:4326', 'EPSG:2193');

        return this.portalService.dataPointQuery(transformedCoordinate, this.layerName(), { cache }, false)
            .then((data: IPointReport|IRequestError) => {
                if ('error' in data) {
                    throw new Error(data.error);
                }
                const layer = data.response.layers.find(l => l.name === this.layerName());
                const titleProp = this.layerService.attributes && this.layerService.attributes.PredefinedFeatureTitleProperty;

                return layer.rows.map(row => {
                    const properties: {[key: string]: any} = {};
                    row.columns.forEach(c => {
                        properties[c.name] = c.value;
                    });

                    if (properties[titleProp]) {
                        properties['_title'] = properties[titleProp];
                    } else if (properties[this.layerService.description]) {
                        properties['_title'] = properties[this.layerService.description];
                    }

                    return { properties };
                });
            });
    }
}
